export enum AccountSubjectType {
  DIRECTOR = 'DIRECTOR',
  FOUNDER = 'FOUNDER',
  PERSON = 'PERSON',
}
